import React, { useEffect, useState } from 'react';
import { Nivel } from '../../types/index';

interface DiaConNivel {
    dia: string;
    nivelId: string;
}

interface ConfiguracionNivelesProps {
    niveles: Nivel[];
    diasSemana: string[];
    frecuenciaSemanal: number;
    onSeleccionNivel: (selecciones: DiaConNivel[]) => void;
}

const ConfiguracionNiveles: React.FC<ConfiguracionNivelesProps> = ({
    niveles,
    diasSemana,
    frecuenciaSemanal,
    onSeleccionNivel,
}) => {
    const [selecciones, setSelecciones] = useState<DiaConNivel[]>([]);
    const [seleccionesCompletas, setSeleccionesCompletas] = useState(false);

    
    useEffect(() => {
        const todasTienenNivel = selecciones.every(s => s.nivelId !== '');
        const estaCompleto = selecciones.length === frecuenciaSemanal && todasTienenNivel;
        
        if (estaCompleto !== seleccionesCompletas) {
            setSeleccionesCompletas(estaCompleto);
            if (estaCompleto) {
                onSeleccionNivel(selecciones);
            }
        }
    }, [selecciones, frecuenciaSemanal, seleccionesCompletas]);


    const handleSeleccionDia = (dia: string) => {
        setSelecciones(prev => {
            // Si el día ya está seleccionado, lo quitamos
            if (prev.some(s => s.dia === dia)) {
                return prev.filter(s => s.dia !== dia);
            }
            // Si no está seleccionado y hay espacio, lo añadimos
            if (prev.length < frecuenciaSemanal) {
                return [...prev, { dia, nivelId: '' }];
            }
            return prev;
        });
    };

    const handleSeleccionNivel = (dia: string, nivelId: string) => {
        setSelecciones(prev => 
            prev.map(s => s.dia === dia ? { ...s, nivelId } : s)
        );
    };

    return (
        <div className="space-y-4">
            <label className="block text-sm font-medium text-gray-700">
                Selecciona el día y nivel para cada clase ({selecciones.length}/{frecuenciaSemanal})
            </label>
            <div className="grid grid-cols-5 gap-4">
                {diasSemana.map(dia => (
                    <div key={dia} className="space-y-2">
                        <div className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id={`dia-${dia}`}
                                checked={selecciones.some(s => s.dia === dia)}
                                onChange={() => handleSeleccionDia(dia)}
                                className="rounded border-gray-300"
                                disabled={
                                    !selecciones.some(s => s.dia === dia) && 
                                    selecciones.length >= frecuenciaSemanal
                                }
                            />
                            <label htmlFor={`dia-${dia}`} className="text-sm font-medium">
                                {dia}
                            </label>
                        </div>
                        {selecciones.some(s => s.dia === dia) && (
                            <select
                                value={selecciones.find(s => s.dia === dia)?.nivelId || ''}
                                onChange={e => handleSeleccionNivel(dia, e.target.value)}
                                className="mt-1 block w-full text-sm rounded-md border-gray-300 shadow-sm"
                            >
                                <option value="">Seleccionar nivel</option>
                                {niveles?.map(nivel => (
                                    <option key={nivel._id} value={nivel._id}>
                                        {nivel.nombre}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConfiguracionNiveles;